/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  color: {
    type: [String, Object, Array],
    "default": ""
  },
  label: {
    type: [String, Boolean, Function],
    "default": true
  },
  percentage: {
    type: Number,
    "default": 0
  },
  size: {
    type: [String, Number],
    "default": "medium"
  },
  status: {
    type: String,
    validator: function validator(val) {
      return ["success", "error", "warning", "active"].includes(val);
    }
  },
  strokeWidth: {
    type: [String, Number]
  },
  theme: {
    type: String,
    "default": "line",
    validator: function validator(val) {
      return ["line", "plump", "circle"].includes(val);
    }
  },
  trackColor: {
    type: String,
    "default": ""
  }
};

export { props as default };
//# sourceMappingURL=props.mjs.map
